module.exports = __webpack_public_path__ + "img/bmwi.svg";